import { render, staticRenderFns } from "./TwitterElement.vue?vue&type=template&id=f3f7b904&"
import script from "./TwitterElement.vue?vue&type=script&lang=js&"
export * from "./TwitterElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports